// © Microsoft Corporation. All rights reserved.

import { requireAsync } from "./RequireAsync";

/**
 * Integration function to retrieve the prime track object.
 *
 * @export
 * @return {Promise<PrimeGlobal.ITrack>} - Resolves if the track object could be loaded, rejects otherwise.
 */
export let getTrack: IGetTrack = () => {
    return requireAsync<PrimeGlobal.ITrack>("track");
};
